import React from 'react';

interface ElementCardButtonProps {
  index: number;
  isOpen: boolean;
  isTitleLeft: boolean;
  content: string;
  onClick: () => void;
}

const ElementCardButton: React.FC<ElementCardButtonProps> = ({
  index,
  isOpen,
  isTitleLeft,
  content,
  onClick,
}) => {
  const classNm = isOpen
    ? 'element-card-button-active ' +
      (isTitleLeft
        ? 'element-card-button-active-left'
        : 'element-card-button-active-right')
    : 'element-card-button';
  return (
    <button key={index} className={`${classNm}`} onClick={onClick}>
      <span />
      {content}
    </button>
  );
};

export default ElementCardButton;
